module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" Firmador Grupal\n      "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar_ventana($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalles),
      expression: "detalles"
    }],
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "demofi-container"
  }, [_c('demofi', {
    attrs: {
      "solicitud": _vm.$store.state.selected,
      "on-success": _vm.cambiarEstado
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    class: {
      xs12: !_vm.detalles
    },
    attrs: {
      "xs8": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "margin-0 p-l-0 p-r-0 p-t-0"
  }, [_c('v-spacer'), _vm._v(" "), (_vm.$store.state.permissions['firmas:create']) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.$store.state.loading
    },
    on: {
      "click": function($event) {
        return _vm.firm(_vm.$store.state.selected)
      }
    }
  }, [_c('v-icon', [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.approve')) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_vm._l((_vm.$store.state.selected), function(item) {
    return [(item.id_archivo === 1) ? _c('v-chip', {
      attrs: {
        "color": "red",
        "text-color": "white"
      }
    }, [_vm._v("\n                Nro. " + _vm._s(item.id) + " - NO TIENE ARCHIVO ADJUNTO\n              ")]) : _c('v-chip', [_vm._v("\n                Nro. " + _vm._s(item.id) + " -\n                " + _vm._s(item.tramite_solicitante_nombres) + "\n                " + _vm._s(item.tramite_solicitante_primer_apellido) + "\n                " + _vm._s(item.tramite_solicitante_segundo_apellido) + " -\n                " + _vm._s(item.documento_nombre) + "\n              ")])]
  }), _vm._v(" "), (!_vm.$store.state.selected || _vm.$store.state.selected === 0) ? _c('div', [
    [_vm._v("\n                No ha seleccionado documentos\n              ")]
  ], 2) : _vm._e()], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-394df5e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramiteDoc/FirmanteGrupal.vue
// module id = 508
// module chunks = 2